import { renderFallbackDom } from './bootstrap-fallback-dom';

let bootstrapFailed = false;
const errorQueue: Array<{ error: unknown; phase: string }> = [];

function handleBootstrapError(error: unknown, phase: string): void {
  errorQueue.push({ error, phase });
  if (bootstrapFailed) {
    return;
  }
  bootstrapFailed = true;
  renderBootstrapFallback(error, phase);
  (
    window as Window & { Sentry?: { captureException?: (e: unknown) => void } }
  ).Sentry?.captureException?.(error);
}

function onWindowError(event: ErrorEvent): void {
  if ((window as Window & { __prosperoReactMounted?: boolean }).__prosperoReactMounted === true) {
    return;
  }
  handleBootstrapError(event.error ?? event.message, 'window.error');
}

function onUnhandledRejection(event: PromiseRejectionEvent): void {
  if ((window as Window & { __prosperoReactMounted?: boolean }).__prosperoReactMounted === true) {
    return;
  }
  handleBootstrapError(event.reason, 'unhandledrejection');
}

window.addEventListener('error', onWindowError, { capture: true });
window.addEventListener('unhandledrejection', onUnhandledRejection);

export function didBootstrapFail(): boolean {
  return bootstrapFailed;
}

export function flushBootstrapErrorsToSentry(Sentry: typeof import('@sentry/react')): void {
  for (const { error, phase } of errorQueue) {
    Sentry.captureException(error, {
      tags: { stage: 'bootstrap', phase },
      level: 'fatal',
    });
  }
  errorQueue.length = 0;
}

export function renderBootstrapFallback(error: unknown, phase: string): void {
  // phase is accepted for future use (e.g. labeling the UI per failure stage)
  void phase;
  renderFallbackDom(error);
}
